import superagent from 'superagent';
import webservice from './webservice';

export default async function getPaqueterias(CP) {
  const url = `${webservice}/getSepomex?cp=${CP}`;
  let response = {};

  await superagent
    .get(url)
    .set('Content-Type', 'application/json')
    .then((res) => {
      response = res.body;
    })
    .catch((err) => {
      console.log(err);
    });

  return response;
}
